// Community Feedback Management APIs

/**
 * @function ApiClient#GetFeedbackList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.hasRead
 * @param {any} params.type
 * @param {any} params.subType
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetFeedbackList(
  cid,
  { sortBy, sortDesc, page, itemsPerPage, startDate, endDate, hasRead, type, subType, building, doorPlate, floor },
  options = {},
) {
  if (!startDate) startDate = "";
  if (!endDate) endDate = "";
  if (!hasRead) hasRead = "";
  if (!type) type = "";
  if (!subType) subType = "";
  if (!building) building = "";
  if (!doorPlate) doorPlate = "";
  if (!floor) floor = "";

  return await this._get(
    `/community/${cid}/feedback_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&hr=${hasRead}&b=${building}&d=${doorPlate}&f=${floor}&t=${type}&sbt=${subType}`,
    options,
  );
}

/**
 * @function ApiClient#ReplyFeedback
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 * @param {any} desc
 * @param {any} files
 * @param {any} images
 * @param {any} options = {}
 */
export async function ReplyFeedback(cid, fid, desc, files, images, options = {}) {
  const formData = new FormData();
  formData.set("Desc", desc);
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  if (images) {
    images.forEach((i) => {
      formData.append("Image", i);
    });
  }

  return await this._post(`/community/${cid}/feedback/${fid}`, formData, options);
}

/**
 * @function ApiClient#EditFeedback
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fid
 * @param {any} desc
 * @param {any} files
 * @param {any} images
 * @param {any} options = {}
 */
export async function EditFeedback(cid, fid, desc, files, images, options = {}) {
  const formData = new FormData();
  formData.set("Desc", desc);
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  if (images) {
    images.forEach((i) => {
      formData.append("Image", i);
    });
  }

  return await this._put(`/community/${cid}/feedback/${fid}`, formData, options);
}

// Feedback Type Management APIs

/**
 * @function ApiClient#GetFeedbackTypeItemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetFeedbackTypeItemList(cid, options = {}) {
  return await this._get(`/community/${cid}/feedback_type_list`, options);
}

/**
 * @function ApiClient#AddFeedbackTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} isRepair = false
 * @param {any} options = {}
 */
export async function AddFeedbackTypeItem(cid, itemName, isRepair = false, options = {}) {
  return await this._post(`/community/${cid}/feedback_type?t=${itemName}&r=${isRepair ? "1" : "0"}`, null, options);
}

/**
 * @function ApiClient#UpdateFeedbackTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} items
 * @param {any} options = {}
 */
export async function UpdateFeedbackTypeItem(cid, items, options = {}) {
  return await this._put(`/community/${cid}/feedback_type`, items, options);
}

/**
 * @function ApiClient#DeleteFeedbackTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function DeleteFeedbackTypeItem(cid, itemName, options = {}) {
  return await this._delete(`/community/${cid}/feedback_type?t=${itemName}`, options);
}

/**
 * @function ApiClient#UpdateFeedbackTypeByID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateFeedbackTypeByID(cid, typeId, data, options = {}) {
  return await this._put(`/community/${cid}/feedback_type/${typeId}`, data, options);
}

/**
 * @function ApiClient#AddFeedbackSubType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeId
 * @param {any} name
 * @param {any} options = {}
 */
export async function AddFeedbackSubType(cid, typeId, name, options = {}) {
  return await this._post(`/community/${cid}/feedback_type/${typeId}/subtype`, { Name: name }, options);
}

/**
 * @function ApiClient#UpdateFeedbackSubTypes
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeId
 * @param {any} subTypes
 * @param {any} options = {}
 */
export async function UpdateFeedbackSubTypes(cid, typeId, subTypes, options = {}) {
  return await this._put(`/community/${cid}/feedback_type/${typeId}/subtype`, { SubTypes: subTypes }, options);
}

/**
 * @function ApiClient#DeleteFeedbackSubType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeId
 * @param {any} subId
 * @param {any} options = {}
 */
export async function DeleteFeedbackSubType(cid, typeId, subId, options = {}) {
  return await this._delete(`/community/${cid}/feedback_type/${typeId}/subtype/${subId}`, options);
}
